import axios from "axios";
import { BASE_URL } from "./config"; // Ensure you create and export BASE_URL in this file

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 403) {
      window.location.href = "/login"; // Redirect to login page
    }
    return Promise.reject(error);
  }
);

const apiRequest =
  (BASE_URL, method = "GET") =>
  async (urlSuffix, data = null, headers = {}) => {
    try {
      const response = await axios({
        method,
        url: `${BASE_URL}${urlSuffix}`,
        data,
        headers: {
          ...headers,
          "Content-Type": "application/json",
          "x-api-key": "test_gnVTNdL8iVQGeq3TKsuK6WHwyTXO6Jht5W0",
        },
      });
      return response.data;
    } catch (error) {
      console.error("API Request Error:", error);
      throw error;
    }
  };

const API_CONSTRUCTOR = (BASE_URL) => {
  return {
    get: apiRequest(BASE_URL, "GET"),
    post: apiRequest(BASE_URL, "POST"),
    patch: apiRequest(BASE_URL, "PATCH"),
  };
};

export default API_CONSTRUCTOR;
